import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import PropertySection from './section-components/available-peroperty';
import Footer from './global-components/footer';
import BlogContact from '../utils/blogContact';

const AvailableProperty = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Availavbe Apartments" subheader="Availavbe" />
        <PropertySection />
        <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
        <Footer />
    </div>
}

export default AvailableProperty

